export default __webpack_public_path__ + "a4ceacdd6532ba12238ac792a29292be.ico";